/**
 * Checks whether the server thinks an auth user exists for this email.
 * This is used to avoid calling `supabase.auth.signUp` when the account already exists,
 * which can trigger an additional confirmation email.
 */
export async function checkAuthUserExistsByEmail(email: string): Promise<{ exists: boolean; confirmed: boolean }> {
  const base = process.env.REACT_APP_STRIPE_SERVER_URL || process.env.REACT_APP_SERVER_URL || '';
  if (!base.trim()) return { exists: false, confirmed: false };

  const url = `${base.replace(/\/+$/, '')}/auth/email-exists`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    // If we can reach the server but it errors, do not silently fall back,
    // because signUp may trigger another confirmation email.
    throw new Error(`Email status check failed (status ${res.status})`);
  }

  const body = (await res.json().catch(() => ({}))) as { exists?: boolean; confirmed?: boolean };
  return {
    exists: Boolean(body.exists),
    confirmed: Boolean(body.confirmed),
  };
}

